export default __webpack_public_path__ + "static/media/mainLogo.348bb42f.png";